import { render, staticRenderFns } from "./ShowFormItem.vue?vue&type=template&id=64d02422"
import script from "./ShowFormItem.vue?vue&type=script&lang=js"
export * from "./ShowFormItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\华水\\hsmanagementsystem\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64d02422')) {
      api.createRecord('64d02422', component.options)
    } else {
      api.reload('64d02422', component.options)
    }
    module.hot.accept("./ShowFormItem.vue?vue&type=template&id=64d02422", function () {
      api.rerender('64d02422', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Formcreated/components/ShowFormItem.vue"
export default component.exports